import { useTrafficStore } from "../stores/useTrafficStore";

export function StaticTrafficBoard() {
  const count = useTrafficStore((state) => state.driverCount);
  const speed = useTrafficStore((state) => state.displayedSpeed);
  const trafficState = useTrafficStore((state) => state.trafficState);

  return (
    <div
      className="static-board"
      role="img"
      aria-label="Simplified traffic board"
    >
      <div className="static-board__lanes" aria-hidden="true">
        {Array.from({ length: 18 }, (_, index) => (
          <span
            key={index}
            className={`static-car static-car--${(index % 4) + 1}`}
          />
        ))}
      </div>
      <div className="static-board__message">
        <span>GRAPHICS REDUCED</span>
        <strong>{count.toLocaleString()} drivers are still the traffic.</strong>
        <span>
          {trafficState} · {Math.round(speed)} MPH
        </span>
      </div>
    </div>
  );
}
